import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { api } from "@/lib/api";

/**
 * Pulls SEO settings from the backend once and renders:
 *  - Google Search Console verification <meta>
 *  - Bing Webmaster verification <meta>
 *  - Google Analytics 4 (gtag) script + config
 * The values are admin-editable from /admin/seo without a redeploy.
 */
export default function AnalyticsLoader() {
  const [seo, setSeo] = useState(null);

  useEffect(() => {
    let live = true;
    api
      .get("/seo/settings")
      .then((r) => {
        if (live) setSeo(r.data);
      })
      .catch(() => {});
    return () => {
      live = false;
    };
  }, []);

  if (!seo) return null;
  const ga = (seo.ga4_id || "").trim();
  const gsc = (seo.gsc_verification || "").trim();
  const bing = (seo.bing_verification || "").trim();
  return (
    <Helmet>
      {gsc && <meta name="google-site-verification" content={gsc} />}
      {bing && <meta name="msvalidate.01" content={bing} />}
      {ga && (
        <script async src={`https://www.googletagmanager.com/gtag/js?id=${ga}`} />
      )}
      {ga && (
        <script>{`
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${ga}');
        `}</script>
      )}
    </Helmet>
  );
}
